import React from "react";
// @ts-expect-error - this will be resolved at build time
import { Box } from "@xsolla/xui-primitives";
import { useResolvedTheme } from "@xsolla/xui-core";
import { BottomBarItem } from "./BottomBarItem";
import type { BottomBarProps } from "./types";

const MAX_ITEMS = 5;

const getDefaultMaxWidth = (count: number): number | string => {
  if (count <= 3) return 240;
  if (count === 4) return 294;
  return "100%";
};

export const BottomBar: React.FC<BottomBarProps> = ({
  items,
  activeKey,
  onItemClick,
  linkComponent,
  maxWidth,
  "aria-label": ariaLabel = "Bottom navigation",
  testID,
  themeMode,
  themeProductContext = "b2c",
}) => {
  const { theme } = useResolvedTheme({ themeMode, themeProductContext });
  const visibleItems = items.slice(0, MAX_ITEMS);

  return (
    <Box
      as="nav"
      role="tablist"
      aria-label={ariaLabel}
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      width="100%"
      maxWidth={maxWidth ?? getDefaultMaxWidth(visibleItems.length)}
      alignSelf="center"
      height={56}
      padding={4}
      borderRadius={8}
      borderWidth={1}
      borderStyle="solid"
      borderColor={theme.colors.control.segmented.border}
      backgroundColor={theme.colors.control.segmented.bg}
      overflow="hidden"
      testID={testID || "bottom-bar"}
    >
      {visibleItems.map((item) => (
        <BottomBarItem
          key={item.key}
          item={item}
          isActive={item.key === activeKey}
          onItemClick={onItemClick}
          linkComponent={linkComponent}
          themeMode={themeMode}
          themeProductContext={themeProductContext}
        />
      ))}
    </Box>
  );
};
